import React from "react";
import styles from "./Skills.module.scss";
import ProfessionalExperience from "./professionalExperience/ProfessionalExperience";
import SkillsExpertise from "./skillsExpertise/SkillsExpertise";

const Skills = ({}) => {
  return (
    <>
      <section className={styles["skills-section"]} id="skills">
        <div className={styles["container"]}>
          <SkillsExpertise />
          <ProfessionalExperience />
        </div>
      </section>
    </>
  );
};

export default Skills;
